import React, { useCallback } from 'react';

import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { getLoginLink } from '@confluence/login-if-anonymous/entry-points/getLoginLink.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { BaseHeartbeatLoadable } from './HeartBeatLoadable.tsx';

export const Heartbeat = (): React.JSX.Element | null => {
	const { isLoggedIn } = useSessionData();
	const { push } = useRouteActions();

	const onAuthenticationFailed = useCallback(() => push(getLoginLink()), [push]);

	// Return null when stable UI is enabled for tests
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return isLoggedIn ? (
		<BaseHeartbeatLoadable onAuthenticationFailed={onAuthenticationFailed} />
	) : null;
};
